import type { FC } from 'react';
import { PiArrowSquareOutBold } from 'react-icons/pi';
import { useHistory } from 'react-router';
import { Stack, TableRow, Typography } from '@mui/material';

import type { ActionItem } from 'src/types/myFollowUp';
import { internationalDateFormat } from 'src/helper/helper';
import { routePaths } from 'src/services/routing/routePaths';
import { useUserContext } from 'src/components/app/context/UserContext';

import StatusPill from './StatusPill';
import TableCell from './TableCell';

import { styles } from './TableRow.styles';

export interface FollowUpTableRowProps extends ActionItem {
  onClick: () => void;
}

const isDateBeforeToday = (inputDate: string): boolean => {
  const dateToCheck = new Date(inputDate);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return dateToCheck < today;
};

const FollowUpTableRow: FC<FollowUpTableRowProps> = ({
  id,
  surveyName,
  surveyId,
  status,
  followUpOwnerName,
  lastModifiedAt,
  createdAt,
  dueAt,
  onClick,
}) => {
  const { switchSurvey } = useUserContext();
  const history = useHistory();
  const dueDateWarning = isDateBeforeToday(dueAt) && status === 'Open';

  return (
    <TableRow onClick={onClick} sx={styles.tableRow}>
      <TableCell>{id}</TableCell>
      <TableCell>
        <Stack
          onClick={(event) => {
            event.stopPropagation();
            switchSurvey(surveyId).then(() => history.push(routePaths.START));
          }}
          direction="row"
          spacing={1}
          sx={styles.survey}
        >
          <PiArrowSquareOutBold size={18} style={{ minWidth: 18 }} />
          <Typography
            title={surveyName}
            sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {surveyName}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell>{followUpOwnerName}</TableCell>
      <TableCell>{internationalDateFormat(new Date(createdAt))}</TableCell>
      <TableCell>
        {lastModifiedAt
          ? internationalDateFormat(new Date(lastModifiedAt))
          : '-'}
      </TableCell>
      <TableCell>
        <Typography
          component="span"
          sx={[dueDateWarning, styles.dueDateWarning].filter(Boolean)}
        >
          {internationalDateFormat(new Date(dueAt))}
        </Typography>
      </TableCell>
      <TableCell>
        <StatusPill status={status} />
      </TableCell>
    </TableRow>
  );
};

export default FollowUpTableRow;
